import { Spinner } from '@movingimage-evp/mi-ui-component-library';

import styles from './viewer-spinner.module.css';

export function ViewerSpinner() {
  return (
    <div className={styles.spinner}>
      <Spinner size={40} />
    </div>
  );
}
